<template>
  <ProductArea :productLinks="productLinks" />
</template>

<script>
import ProductArea from "../../components/ProductArea/ProductArea.vue";

export default {
  name: "app",
  components: {
      ProductArea
  },
  data() {
    return {
        productLinks: JSON.parse(this.$options._parentVnode.data.props.productLinks),
    };
  }
};
</script>
